// extracted by mini-css-extract-plugin
module.exports = {"PageButton":"PageButton_PageButton__rzVe1","selected":"PageButton_selected__3_B9s","ellipses":"PageButton_ellipses__MMSHO"};